"use strict";

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Formatter_1 = __importDefault(require("./internal/Formatter"));

var PROPERTIES_PANE = 'PropertiesPane';
var CONDITIONAL_PALETTE_TYPE = 'ConditionalPalette';
var CONDITIONAL_COLOR_PANEL = 'ConditionalColorPanel';
var CONDITIONAL_COLOR = 'ConditionalColor';
var ALLOW_SET_RULE_EXPAND_FLAG_CALLERS = ['RuleComponent', 'ConditionalFormatModel:addRule'];

var ColorPalettes =
/** @class */
function () {
  function ColorPalettes() {}

  return ColorPalettes;
}();

var hasPaletteId = function hasPaletteId(paletteId, colorPalettes) {
  var keys = Object.keys(colorPalettes);
  return keys.includes(paletteId);
};

var UIContext =
/** @class */
function () {
  function UIContext(options) {
    if (options === void 0) {
      options = {};
    }

    this.dashboardApi = options.dashboardApi;

    if (!this.dashboardApi) {
      // The this.dashboardApi must always be valid
      throw new Error('Invalid dashboardApi');
    }

    this.condFormatApi = options.condFormatApi;
    this.colors = options.colors;
    this.icons = options.icons;
    this.conditionalFormattingState = options.conditionalFormattingState;
    this.dataSourceUI = options.dataSourceUI;
    this.contentId = options.contentId;
    this.paletteServicePromise = this.dashboardApi.getGlassSvc('.Palette');
    this.colorPalettes = new ColorPalettes();
    this.palettes = new ColorPalettes();
    this.paletteColors = new Map();
    this._disposeFns = [];
    var inAppSlideoutState = this.dashboardApi.getFeature('InAppSlideoutState');

    if (inAppSlideoutState) {
      // UI Support for Conditional Formatting
      // inAppSlideoutState instance is used to determine that we are in the CA-Dashboard UI
      this._canvasReadyPromise = this.dashboardApi.getCanvasWhenReady();
      var inAppSlideoutDOM = this.dashboardApi.getFeature('InAppSlideoutDOM');

      this._disposeFns.push(inAppSlideoutDOM.onDomStateChange(this._onSlideoutDOMMountedChange.bind(this)));

      this.propertiesManager = this.dashboardApi.getFeature('propertiesManager');
    } // Set here to avoid circular dependency since UIContext depends on ConditionalFormattingState


    this.conditionalFormattingState.setUIContext(this);
  }

  UIContext.prototype.destroy = function () {
    this._removeUIComponents();

    this._disposeFns.forEach(function (fn) {
      return fn();
    });

    this._disposeFns.length = 0;
  };

  UIContext.prototype.paletteServiceIsReady = function () {
    var _this = this;

    return this.paletteServicePromise.then(function (paletteService) {
      _this.paletteService = paletteService;
    });
  };

  UIContext.prototype.getPaletteService = function () {
    return this.paletteService;
  };

  UIContext.prototype.getConditionalFormattingState = function () {
    return this.conditionalFormattingState;
  };

  UIContext.prototype.getIcons = function () {
    return this.icons;
  };

  UIContext.prototype.setMeasureDataItem = function (measure) {
    this.conditionalFormattingState.setMeasureDataItem(measure);
  };

  UIContext.prototype.selectMeasureAddedToSlot = function (measure) {
    return this.conditionalFormattingState.selectMeasureAddedToSlot(measure);
  };

  UIContext.prototype.setMeasures = function (measures) {
    this.conditionalFormattingState.setMeasures(measures);
  };

  UIContext.prototype.getConditionalFormatModel = function () {
    return this.conditionalFormattingState.getConditionalFormatModel();
  };

  UIContext.prototype.format = function (value, spec) {
    return Formatter_1.default.format(value, spec);
  };

  UIContext.prototype.getNumberFromFormattedValue = function (formattedValue) {
    if (formattedValue === void 0) {
      formattedValue = '';
    }

    if (formattedValue.endsWith('%')) {
      formattedValue = formattedValue.substring(0, formattedValue.length - 1);
    } // This code is currently in LW: js/util/DashboardFormatter.js so just do a copy here for now
    // until after speaking with Rami


    var groupingSeperator = Formatter_1.default.formatNumber(1000).substring(1, 2);
    var decimalSeperator = Formatter_1.default.formatNumber(0.1).substring(1, 2);
    var patternGrp = new RegExp('\\' + groupingSeperator, 'g');
    var patternDecimal = new RegExp('\\' + decimalSeperator, 'g');
    return Number(formattedValue.replace(patternGrp, '').replace(patternDecimal, '.'));
  };

  UIContext.prototype.setHasTargetValue = function (value) {
    this.conditionalFormattingState.setHasTargetValue(value);
  };

  UIContext.prototype.displayChildPanel = function (options) {
    if (options === void 0) {
      options = {};
    }

    var addChildPanelFn; // @todo Explore have plans to use InAppSlideout post R7
    // Have work with Explore post R7 to integate it using the Dashboard's InAppSlideout
    // This code here is only meant to support Explore in R7
    // In R8 Explore will use the same Properties Panel Slideout as in Dashboard so this is no longer needed
    // We don't know at what point Explore register itself as a provider so we always do the check here first
    // Since Explore cannot register itself as a provider during intialize or initializeFeature call

    var provider = this.condFormatApi.getProvider();

    if (provider && provider.addChildPropertyPanel) {
      addChildPanelFn = provider.addChildPropertyPanel.bind(provider);
    }

    if (!addChildPanelFn) {
      addChildPanelFn = this.propertiesManager.addChild.bind(this.propertiesManager);
    }

    if (!addChildPanelFn) {
      throw new Error('Cannot addChild panel');
    }

    addChildPanelFn(options);
    this.conditionalFormattingState.setCurrentUIPanelId(options.content.panelId);
  };

  UIContext.prototype.hasDisplayedChildPanel = function () {
    var child = this.propertiesManager.getCurrentChild();
    return !!child;
  };

  UIContext.prototype.closeAllChildPanel = function () {
    // close all opened child panels (Change palette view, CF panel for measure data time)
    // when a data item is removed from slot
    this.propertiesManager.closeAllChild();
  };

  UIContext.prototype.displayChildPanelForMeasure = function (measureDataItem) {
    if (!measureDataItem) {
      throw new Error('Invalid measureDataItem provided');
    }

    var mstForUIPanels = this.conditionalFormattingState.getMstForUIPanels();
    mstForUIPanels.setMeasureDataItem(measureDataItem);
    var options = {
      label: measureDataItem.getDataItemId(),
      overlay: true,
      width: '300px',
      content: {
        id: 'conditionalColor',
        module: 'dashboard-analytics/features/content/conditionalFormatting/ConditionalFormatting',
        moduleClass: 'ConditionalColorPanel',
        component: 'dashboard',
        uiContext: this,
        panelId: 'childCFPanel'
      }
    };
    this.displayChildPanel(options);
  };

  UIContext.prototype.removeUiConditionalColorPanel = function () {
    if (this.uiConditionalColorPanel) {
      this.uiConditionalColorPanel.remove();
      this.uiConditionalColorPanel = null;
      this.rulesComponentReactRef = null;
      this.conditionalFormattingState.resetCurrentUIPanelId();
    }
  };

  UIContext.prototype.getDataSourceUI = function () {
    return this.dataSourceUI;
  };

  UIContext.prototype.getSourceId = function () {
    return this.sourceId;
  };

  UIContext.prototype.setSourceId = function (sourceId) {
    this.sourceId = sourceId;
  };

  UIContext.prototype.getDataSource = function () {
    return this.dataSource;
  };

  UIContext.prototype.setDataSource = function (dataSource) {
    this.dataSource = dataSource;
  };

  UIContext.prototype.getContentId = function () {
    return this.contentId;
  };

  UIContext.prototype.hasValidDataSourceId = function () {
    return this.sourceId && this.sourceId.length > 0;
  };

  UIContext.prototype.isKpiVis = function () {
    return this.conditionalFormattingState.isKpiVis();
  };

  UIContext.prototype.getColors = function () {
    return this.colors;
  };

  UIContext.prototype.setExpandRuleFlag = function (callFrom, dataItemId, ruleIndex, expand) {
    // Expand/Collapse Rule is only available in the UI
    // Only 2 UI components are allowed to call this function
    // 1. RuleComponent is allow to call with expand = false | true
    // 2. ConditionalFormatModel:addRule is only allow to call with expand = true
    if (!ALLOW_SET_RULE_EXPAND_FLAG_CALLERS.includes(callFrom) || !expand && callFrom !== 'RuleComponent') {
      throw new Error("setExpandRuleFlag is not allowed for " + callFrom);
    }

    this.conditionalFormattingState.setExpandRuleFlag(dataItemId, ruleIndex, expand);
  };

  UIContext.prototype.registerUIConditionalColor = function (uiConditionalColor) {
    if (this.uiConditionalColor) {
      this.uiConditionalColor.remove();
    }

    if (this.rulesComponentReactRef && this.rulesComponentReactRef.parentId === CONDITIONAL_COLOR) {
      this.rulesComponentReactRef = null;
    }

    this.uiConditionalColor = uiConditionalColor;
  };

  UIContext.prototype.registerUIConditionalColorPanel = function (uiConditionalColorPanel) {
    if (this.uiConditionalColorPanel) {
      this.uiConditionalColorPanel.remove();
    }

    if (this.rulesComponentReactRef && this.rulesComponentReactRef.parentId === CONDITIONAL_COLOR_PANEL) {
      this.rulesComponentReactRef = null;
    }

    this.uiConditionalColorPanel = uiConditionalColorPanel;
  };

  UIContext.prototype.setRulesComponentReactRef = function (value) {
    /**
     * The RulesComponent can be instantiate from:
     *
     * CONDITIONAL_COLOR for KPI
     *
     * OR
     *
     * CONDITIONAL_COLOR_PANEL for xtab and table
     */
    this.rulesComponentReactRef = {
      reactRef: value,
      parentId: this.uiConditionalColorPanel ? CONDITIONAL_COLOR_PANEL : CONDITIONAL_COLOR
    };
  };

  UIContext.prototype.setConditionalColorPanelComponent = function (value) {
    this.conditionalColorPanelComponents = value;
  };

  UIContext.prototype.onCloseChangePaletteView = function () {
    var reactRef = this.rulesComponentReactRef ? this.rulesComponentReactRef.reactRef : null;
    var child = reactRef && reactRef.current ? reactRef.current.child : {};

    if (child['expandExpandableTile']) {
      child['expandExpandableTile']();
    }

    this.conditionalFormattingState.resetCurrentUIPanelId();
  };

  UIContext.prototype.collapseExpandableTile = function () {
    var reactRef = this.rulesComponentReactRef ? this.rulesComponentReactRef.reactRef : null;
    var child = reactRef && reactRef.current ? reactRef.current.child : {};

    if (child['collapseExpandableTile']) {
      child['collapseExpandableTile']();
    }
  };

  UIContext.prototype.getPaletteColorsForPaletteId = function (paletteId) {
    return this.paletteColors.get(paletteId) || [];
  };

  UIContext.prototype.getColorPalette = function (paletteId) {
    return __awaiter(this, void 0, void 0, function () {
      var type, addMissingBaseColors;

      var _this = this;

      return __generator(this, function (_a) {
        if (!hasPaletteId(paletteId, this.colorPalettes)) {
          type = CONDITIONAL_PALETTE_TYPE;
          addMissingBaseColors = true;
          this.colorPalettes[paletteId] = this.colors.getPaletteColors({
            paletteId: paletteId,
            type: type,
            addMissingBaseColors: addMissingBaseColors
          });
        }

        return [2
        /*return*/
        , this.colorPalettes[paletteId].then(function (paletteColors) {
          _this.paletteColors.set(paletteId, paletteColors);

          return paletteColors;
        })];
      });
    });
  };

  UIContext.prototype.getFavoriteColors = function () {
    return __awaiter(this, void 0, void 0, function () {
      var cmFavoriteColors;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.paletteService.getFavoriteColors()];

          case 1:
            cmFavoriteColors = _a.sent();
            return [2
            /*return*/
            , cmFavoriteColors || []];
        }
      });
    });
  };

  UIContext.prototype.getPalette = function (paletteId) {
    return __awaiter(this, void 0, void 0, function () {
      var type;
      return __generator(this, function (_a) {
        if (!paletteId || paletteId.length === 0) {
          return [2
          /*return*/
          , Promise.resolve([])];
        }

        if (!hasPaletteId(paletteId, this.palettes)) {
          type = CONDITIONAL_PALETTE_TYPE;
          this.palettes[paletteId] = this.colors.getPalette({
            paletteId: paletteId,
            type: type
          });
        }

        return [2
        /*return*/
        , this.palettes[paletteId]];
      });
    });
  };

  UIContext.prototype.getPalettes = function () {
    return __awaiter(this, void 0, void 0, function () {
      var type, forProperties, includePatternPalettes, palettes;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            type = CONDITIONAL_PALETTE_TYPE;
            forProperties = true;
            includePatternPalettes = !this.isKpiVis();
            return [4
            /*yield*/
            , this.colors.getPalettes({
              type: type,
              forProperties: forProperties,
              includePatternPalettes: includePatternPalettes
            })];

          case 1:
            palettes = _a.sent();
            return [2
            /*return*/
            , palettes];
        }
      });
    });
  };

  UIContext.prototype.getConditionalFormatsModel = function () {
    return this.conditionalFormattingState.getStateModel();
  };

  UIContext.prototype._onSlideoutDOMMountedChange = function (state) {
    var _this = this;

    if (state === void 0) {
      state = {};
    }

    if (state['current'] !== PROPERTIES_PANE) {
      return Promise.resolve();
    }

    return this._canvasReadyPromise.then(function (canvas) {
      var selectedContents = canvas.getSelectedContentList(); // Only allow one selected vis at a time for the Properties Panel

      if (selectedContents.length === 1) {
        var content = selectedContents[0];
        var contentType = content && content.getType();
        var selectedContentId = content && content.getId();

        if (contentType === 'widget.live' && selectedContentId === _this.getContentId()) {
          if (state['type'] === 'mounted') {
            var reactRef = _this.rulesComponentReactRef ? _this.rulesComponentReactRef.reactRef : null;
            var child = reactRef && reactRef.current ? reactRef.current.child : {};

            if (child['onPropertiesPanelMounted']) {
              child['onPropertiesPanelMounted']();
            }

            if (_this.conditionalColorPanelComponents) {
              _this.conditionalColorPanelComponents.onSlideoutMounted();
            }
          } else {
            _this._removeUIComponents();
          }
        }
      }
    });
  };

  UIContext.prototype._removeUIComponents = function () {
    if (this.uiConditionalColorPanel) {
      this.uiConditionalColorPanel.remove();
      this.uiConditionalColorPanel = null;
      this.rulesComponentReactRef = null;
    }

    if (this.uiConditionalColor) {
      this.uiConditionalColor.remove();
      this.uiConditionalColor = null;
    }

    this.rulesComponentReactRef = null;
    this.conditionalColorPanelComponents = null;
  };

  return UIContext;
}();

exports.default = UIContext;
